import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { setJSONLocalStorage, getJSONLocalStorage, getToken } from '../../functions/app_functions.js';
import Triplist from './triplist.js';
import Saleslist from './saleslist.js';
import Orderlist from './orderlist.js';
import Payoutlist from './payoutlist.js';


export default class UserDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            badges_updated: [],
            updated: false,
            status: null,
            balance: null,
            orders: null,
            payouts: null,
            credits: null
        };
        this.updateData = this.updateData.bind(this);
        this.setUser = this.setUser.bind(this);
    }


    componentDidMount() {
        this.setState({
            badges_updated: this.props.userdata.badges
        });

        this.props.userdata.user_id && this.loadData(this.props.userdata.user_id);
    }


    loadData(user_id) {
        this.loadUserCurrentBalance(user_id);
        this.loadUserOrdersData(user_id);
        this.loadUserSalesData(user_id);
        this.loadUserPayoutsData(user_id);
    }


    setUser(user_id) {
        this.props.setUser(user_id);
        this.loadData(user_id);
    }


    async loadUserCurrentBalance(user_id) {
        try {
            var data_storage = getJSONLocalStorage(user_id + "_usercurrentbalance", 1);
            if (data_storage && data_storage.length > 0) {
                this.setState({
                    balance: parseFloat(data_storage)
                });
            }
            // Send request
            var response = await fetch(this.props.baseUrl + "/getcreatorcurrentbalance", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${getToken()}`
                },
                body: JSON.stringify({
                    user_id: user_id
                }),
            });
            // Process response
            response = await response.json();
            var data = response.value;
            if (data) {
                this.setState({
                    balance: parseFloat(data.balance)
                });
                setJSONLocalStorage(user_id + "_usercurrentbalance", data);
            } else {
                // Track error
                var name = "";
                var message = "Could not load current balance data. Please try again.";
                this.props.setError(name, message);
            }
            window.scrollTo(0, 0);
        } catch (error) {
            // Track error
            var name = "";
            var message = "Could not load current balance data. Please try again.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "userDetails_loadUserCurrentBalance");
        }
    }


    async loadUserOrdersData(user_id) {
        try {
            var data_storage = getJSONLocalStorage(user_id + "_userordersdata", 1);
            if (data_storage && data_storage.length > 0) {
                this.setState({
                    orders: data_storage
                });
            }
            // Send request
            var response = await fetch(this.props.baseUrl + "/getbuyerordersdata", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${getToken()}`
                },
                body: JSON.stringify({
                    user_id: user_id
                }),
            });
            // Process response
            response = await response.json();
            var data = response.value;
            if (data) {
                this.setState({
                    orders: data
                });
                setJSONLocalStorage(user_id + "_userordersdata", data);
            } else {
                // Track error
                var name = "";
                var message = "Could not load order data. Please try again.";
                this.props.setError(name, message);
            }
            window.scrollTo(0, 0);
        } catch (error) {
            // Track error
            var name = "";
            var message = "Could not load order data. Please try again.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "userDetails_loadUserOrdersData");
        }
    }


    async loadUserSalesData(user_id) {
        try {
            var data_storage = getJSONLocalStorage(user_id + "_usersalesdata", 1);
            if (data_storage && data_storage.length > 0) {
                this.setState({
                    credits: data_storage
                });
            }
            // Send request
            var response = await fetch(this.props.baseUrl + "/getsellerordersdata", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${getToken()}`
                },
                body: JSON.stringify({
                    user_id: user_id
                }),
            });
            // Process response
            response = await response.json();
            var data = response.value;
            if (data) {
                this.setState({
                    credits: data
                });
                setJSONLocalStorage(user_id + "_usersalesdata", data);
            } else {
                // Track error
                var name = "";
                var message = "Could not load sales data. Please try again.";
                this.props.setError(name, message);
            }
            window.scrollTo(0, 0);
        } catch (error) {
            // Track error
            var name = "";
            var message = "Could not load sales data. Please try again.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "userDetails_loadUserSalesData");
        }
    }


    async loadUserPayoutsData(user_id) {
        try {
            var data_storage = getJSONLocalStorage(user_id + "_userpayoutdata", 1);
            if (data_storage && data_storage.length > 0) {
                this.setState({
                    payouts: data_storage
                });
            }
            // Send request
            var response = await fetch(this.props.baseUrl + "/getcreatorpayoutsdata", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${getToken()}`
                },
                body: JSON.stringify({
                    user_id: user_id
                }),
            });
            // Process response
            response = await response.json();
            var data = response.value;
            if (data) {
                this.setState({
                    payouts: data
                });
                setJSONLocalStorage(user_id + "_userpayoutdata", data);
            } else {
                // Track error
                var name = "";
                var message = "Could not load payouts data. Please try again.";
                this.props.setError(name, message);
            }
            window.scrollTo(0, 0);
        } catch (error) {
            // Track error
            var name = "";
            var message = "Could not load payouts data. Please try again.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "userDetails_loadUserPayoutsData");
        }
    }


    toggleBadge(badge) {
        var data = this.state.badges_updated;
        if (data.includes(badge)) {
            console.log("Remove " + badge);
            data = data.filter(item => item !== badge);
        } else {
            console.log("Add " + badge);
            data.push(badge);
        }
        this.setState({
            badges_updated: data,
            updated: true
        })
    }


    async updateData() {
        try {
            var data = {
                collection: this.state.badges_updated
            };
            var user_id = this.props.userdata.user_id;
            // Send request
            var response = await fetch(this.props.baseUrl + "/adminupdateuserdata", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${getToken()}`
                },
                body: JSON.stringify({
                    user_id: user_id,
                    data: data
                }),
            });
            // Process response
            response = await response.json();
            var data = response.value;
            if (data) {
                // Set success message
                this.props.loadUserData();
                this.setState({
                    status: "Updated",
                    updated: false
                });
            } else {
                // Track error
                var name = "";
                var message = "Could not update data. Please check the URL and try again.";
                this.props.setError(name, message);
            }
        } catch (error) {
            // Track error
            var name = "";
            var message = "Could not update data. Please check the URL and try again.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "UserDetails_updateData");
        }
    }


    render() {
        return (
            <>
                <div className="admindashboard__section">
                    <div className="admindashboard__section__title text-title">
                        User
                    </div>
                    <div className="admindashboard__section__content">

                        {this.props.userdata &&
                            <>
                                <div className="admindashboard__section__content__table admindashboard__section__content__table--userdetails">

                                    <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                        User ID
                                    </div>
                                    <div className="admindashboard__section__content__table__element">
                                        {this.props.userdata.user_id}
                                    </div>

                                    <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header text-link">
                                        Username
                                    </div>
                                    <Link to={"/u/" + this.props.userdata.username} className="admindashboard__section__content__table__element">
                                        {this.props.userdata.username}
                                    </Link>

                                    <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                        Name
                                    </div>
                                    <div className="admindashboard__section__content__table__element">
                                        {this.props.userdata.name}
                                    </div>

                                    {(this.state.balance || this.state.balance === 0) &&
                                        <>
                                            <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                                Balance
                                            </div>
                                            <div className="admindashboard__section__content__table__element">
                                                {this.state.balance}
                                            </div>
                                        </>
                                    }

                                    {this.state.orders &&
                                        <>
                                            <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                                Orders
                                            </div>
                                            <div className="admindashboard__section__content__table__element">
                                                {this.state.orders.length}
                                            </div>
                                        </>
                                    }

                                    {this.state.credits &&
                                        <>
                                            <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                                Sales
                                            </div>
                                            <div className="admindashboard__section__content__table__element">
                                                {this.state.credits.length}
                                            </div>
                                        </>
                                    }

                                    {this.state.payouts &&
                                        <>
                                            <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                                Payouts
                                            </div>
                                            <div className="admindashboard__section__content__table__element">
                                                {this.state.payouts.length}
                                            </div>
                                        </>
                                    }

                                    <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                        Badges
                                    </div>
                                    <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--flex">
                                        {this.props.badges && this.props.badges.length >= 1 && this.props.badges.map((el, i) =>
                                            <div key={i} onClick={() => this.toggleBadge(el)} className={"label" + (this.state.badges_updated.includes(el) ? "" : " label--unselected")}>
                                                {el}
                                            </div>
                                        )}
                                    </div>

                                </div>

                                {(this.state.updated) &&
                                    <div onClick={this.updateData} className="button button-primary">
                                        Update data
                                    </div>
                                }
                                {this.state.status &&
                                    <div className="text-color-primary">
                                        {this.state.status}
                                    </div>
                                }
                            </>
                        }

                    </div>
                </div>

                {this.props.tripdata &&
                    <Triplist
                        tripdata={this.props.tripdata}
                        setTrip={this.props.setTrip}
                    />
                }

                {this.state.credits &&
                    <Saleslist
                        data={this.state.credits}
                        setTrip={this.props.setTrip}
                        setUser={this.setUser}
                    />
                }

                {this.state.orders &&
                    <Orderlist
                        data={this.state.orders}
                        setTrip={this.props.setTrip}
                        setUser={this.setUser}
                    />
                }

                {this.state.payouts &&
                    <Payoutlist
                        data={this.state.payouts}
                        setTrip={this.props.setTrip}
                        setUser={this.setUser}
                    />
                }

            </>
        )
    }
}